/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Payment_Conditions_TitleInputs */

const en_case_payment_conditions_title = /** @type {(inputs: Case_Payment_Conditions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment conditions`)
};

const pt_br2_case_payment_conditions_title = /** @type {(inputs: Case_Payment_Conditions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condições de pagamento`)
};

/**
* | output |
* | --- |
* | "Payment conditions" |
*
* @param {Case_Payment_Conditions_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_conditions_title = /** @type {((inputs?: Case_Payment_Conditions_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Conditions_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_conditions_title(inputs)
	return pt_br2_case_payment_conditions_title(inputs)
});